"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadBlogPosts = exports.FetchBlogPosts = exports.FetchBlogPostsActionTypes = exports.BlogPostsActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var BlogPostsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_BLOG_POSTS: null,
  FETCH_BLOG_POSTS: null
}, 'blog');
exports.BlogPostsActionTypes = BlogPostsActionTypes;
var FetchBlogPostsActionTypes = (0, _actions.createRequestTypes)(BlogPostsActionTypes.FETCH_BLOG_POSTS);
exports.FetchBlogPostsActionTypes = FetchBlogPostsActionTypes;
var FetchBlogPosts = (0, _actions.createRequestActions)(FetchBlogPostsActionTypes);
exports.FetchBlogPosts = FetchBlogPosts;
var loadBlogPosts = (0, _fluxActions.createAction)(BlogPostsActionTypes.LOAD_BLOG_POSTS);
exports.loadBlogPosts = loadBlogPosts;